const groupBy = (keys: any[]) => (array: any[]) => array.reduce((objectsByKeyValue, obj) => {
  const value = keys.map((key) => obj[key]).join('-');
  // eslint-disable-next-line no-param-reassign
  objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
  return objectsByKeyValue;
}, {});

export default groupBy;
